import React, { useMemo } from "react";
import Tile from "./tile";
import classes from "./tileList.module.css";

const swatchList = (props) => {
  const {
    optionEnabled,
    availableOptions,
    getItemKey,
    selectedValue = {},
    items,
    onSelectionChange,
    attribute_code,
  } = props;

  const tiles = useMemo(
    () =>
      items.map((item) => {
        const isSelected = item.label === selectedValue.label;
        const isAvailable = availableOptions?.option_value_uids.includes(
          item.uid
        );

        return (
          <Tile
            optionEnabled={optionEnabled}
            key={getItemKey(item)}
            isSelected={isSelected}
            isAvailable={isAvailable}
            item={item}
            attribute_code={attribute_code}
            onClick={onSelectionChange}
          />
        );
      }),
    [
      getItemKey,
      selectedValue.label,
      items,
      onSelectionChange,
      optionEnabled,
      availableOptions,
      attribute_code,
    ]
  );

  return <div className={classes.root}>{tiles}</div>;
};

export default swatchList;
